// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__oc86K","checkbox":"Checkbox_checkbox__5-ZNj","children":"Checkbox_children__h8dn4"};